import {
  PROFILE_EVALUATION_VIEW_CURRENT,
  PROFILE_EVALUATION_EDIT_CURRENT,
  PROFILE_EVALUATION_CREATE_NEW,
  PROFILE_EVALUATION_VIEW_ARCHIVE,
} from "@/rbac/links.js";

import { VIEW_PROFILE_EVALUATION } from "@/rbac/permissions.js";

function props(route) {
  let orderByDefault = route.query.order_by_id || "desc";

  if (
    route.query.order_by_eval_date ||
    route.query.order_by_status ||
    route.query.order_by_evaluator_full_name
  ) {
    orderByDefault = null;
  }

  return {
    id: route.params.id,

    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 10,

    order_by_id: orderByDefault,

    order_by_eval_date: route.query.order_by_eval_date || null,

    evaluator_id: parseInt(route.query.evaluator_id) || null,
    order_by_evaluator_full_name:
      route.query.order_by_evaluator_full_name || null,

    program_code_1_id: parseInt(route.query.program_code_1_id) || null,
    program_code_2_id: parseInt(route.query.program_code_2_id) || null,
    program_code_3_id: parseInt(route.query.program_code_3_id) || null,

    status: route.query.status || null,
    order_by_status: route.query.order_by_status || null,
  };
}

const clientProfileEvaluationRoutes = [
  {
    path: "profile-evaluations",
    name: "ClientProfileEvaluationIndex",
    meta: {
      title: "Profile Evaluation Archive",
      permission: PROFILE_EVALUATION_VIEW_ARCHIVE,
    },
    props: (route) => props(route),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-index" */ "@/views/client/profile-evaluation/Index.vue"
      ),
  },
  {
    path: "profile-evaluations/create",
    name: "ClientProfileEvaluationCreate",
    meta: {
      title: "Create Profile Evaluation",
      permission: PROFILE_EVALUATION_CREATE_NEW,
    },
    props: (route) => ({
      id: route.params.id,
    }),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-create" */ "@/views/client/profile-evaluation/Create.vue"
      ),
  },
  {
    path: "profile-evaluations/edit-current",
    name: "ClientProfileEvaluationEditCurrent",
    meta: {
      title: "Edit Profile Evaluation",
      permission: PROFILE_EVALUATION_EDIT_CURRENT,
    },
    props: (route) => ({
      id: route.params.id,
    }),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-edit-current" */ "@/views/client/profile-evaluation/EditCurrent.vue"
      ),
  },
  {
    path: "profile-evaluations/view-current",
    name: "ClientProfileEvaluationViewCurrent",
    meta: {
      title: "View Profile Evaluation",
      permission: PROFILE_EVALUATION_VIEW_CURRENT,
    },
    props: (route) => ({
      id: route.params.id,
    }),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-view-current" */ "@/views/client/profile-evaluation/ViewCurrent.vue"
      ),
  },
  {
    // Must precede the :evaluationId route so "trends" is not read as an id.
    path: "profile-evaluations/trends",
    name: "ClientProfileEvaluationTrends",
    meta: {
      title: "Progress Trends",
      permission: VIEW_PROFILE_EVALUATION,
    },
    props: (route) => ({
      id: route.params.id,
    }),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-trends" */ "@/views/client/profile-evaluation/Trends.vue"
      ),
  },
  {
    path: "profile-evaluations/:evaluationId",
    name: "ClientProfileEvaluationView",
    meta: {
      title: "View Profile Evaluation",
      permission: VIEW_PROFILE_EVALUATION,
    },
    props: (route) => ({
      id: route.params.id,
      evaluationId: parseInt(route.params.evaluationId),
    }),
    component: () =>
      import(
        /* webpackChunkName: "client-profile-evaluation-view" */ "@/views/client/profile-evaluation/View.vue"
      ),
  },
  {
    // Drafts are edited on the edit-current screen; the per-id edit view was
    // never built, so keep the name as a redirect for existing links.
    path: "profile-evaluations/:evaluationId/edit",
    name: "ClientProfileEvaluationEdit",
    redirect: (route) => ({
      name: "ClientProfileEvaluationEditCurrent",
      params: { id: route.params.id },
    }),
  },
];

export default clientProfileEvaluationRoutes;
